import { useMutation } from "@tanstack/react-query";
import { PatchTask } from "@coworker/apprestructured/src/task-management/types/Task";
import { updateTask } from "@coworker/apprestructured/src/task-management/services/tasks.service";

export const useUpdateTask = () => {
  return useMutation({
    mutationFn: ({ id, patchTask }: { id: string; patchTask: PatchTask }) =>
      updateTask(id, patchTask),
  });
};
